import { PhListPlus } from '@phosphor-icons/vue'
import IconQuestionnaires from '@/components/icons/IconQuestionnaires.vue'
import type { RouteRecordRaw } from 'vue-router'

const needManagerHomeRoutesNames = {
  needManagerHomePage: 'needManagerHomePage',
  needManagerHomeQuestionnaires: 'needManagerHomeQuestionnaires',
  needManagerHomeRecommendations: 'needManagerHomeRecommendations',
  needManagerHomeFeedbackList: 'needManagerHomeFeedbackList',
  needManagerHomeStudents: 'needManagerHomeStudents'
}

const needManagerRoutesNames = {
  needManagerQuestionnaires: 'needManagerQuestionnaires',
  needManagerQuestionnaireDomains: 'needManagerQuestionnaireDomains',
  needManagerQuestionnaireQuestions: 'needManagerQuestionnaireQuestions',
  needManagerStudents: 'needManagerStudents',
  needManagerDirectory: 'needManagerDirectory',
  needManagerGroups: 'needManagerGroups',
  needManagerGroupStudents: 'needManagerGroupStudents',
  needManagerManageStudents: 'needManagerManageStudents',
  needManagerRecommendation: 'needManagerRecommendation',
  needManagerAddRecommendations: 'needManagerAddRecommendations',
  needManagerFeedbackList: 'needManagerFeedbackList',
  needManagerAddFeedback: 'needManagerAddFeedback',
  ...needManagerHomeRoutesNames
}

const home: RouteRecordRaw =
{
  path: 'home',
  name: needManagerHomeRoutesNames.needManagerHomePage,
  meta: {
    label: 'Home',
    icon: PhDatabase
  },
  redirect: { name: needManagerHomeRoutesNames.needManagerHomeQuestionnaires },
  component: () => import('@/layouts/RouterTabsLayout.vue'),
  children: [
    {
      path: 'questionnaires',
      name: needManagerHomeRoutesNames.needManagerHomeQuestionnaires,
      meta: {
        parentName: needManagerHomeRoutesNames.needManagerHomePage,
        label: 'Questionnaires',
        icon: IconQuestionnaires
      },
      component: () => import('@/features/questionnaires/QuestionnairesList.vue')
    },
    {
      path: 'recommendations',
      name: needManagerHomeRoutesNames.needManagerHomeRecommendations,
      meta: {
        parentName: needManagerHomeRoutesNames.needManagerHomePage,
        label: 'Recommendations',
        icon: PhSparkle
      },
      component: () => import('@/views/need-manager/recommendations/NeedManagerHomeRecommendations.vue')
    },
    {
      path: 'feedback',
      name: needManagerHomeRoutesNames.needManagerHomeFeedbackList,
      meta: {
        parentName: needManagerHomeRoutesNames.needManagerHomePage,
        label: 'Feedback',
        icon: PhListPlus
      },
      component: () => import('@/features/feedback/FeedbackHomeList.vue')
    },
    {
      path: 'students',
      name: needManagerHomeRoutesNames.needManagerHomeStudents,
      meta: {
        parentName: needManagerHomeRoutesNames.needManagerHomePage,
        label: 'Students',
        icon: PhStudent
      },
      component: () => import('@/features/students/StudentsList.vue')
    }
  ]
}

const needManagerRoutes: RouteRecordRaw[] = [
  home,
  {
    path: 'questionnaires',
    name: needManagerRoutesNames.needManagerQuestionnaires,
    meta: {
      label: 'Questionnaires',
      icon: IconQuestionnaires
    },
    component: () => import('@/features/questionnaires/QuestionnairesList.vue')
  },
  {
    path: 'questionnaires/:id/domains',
    name: needManagerRoutesNames.needManagerQuestionnaireDomains,
    meta: {
      parentName: needManagerRoutesNames.needManagerQuestionnaires,
      notRenderInSidebar: true
    },
    component: () => import('@/features/questionnaires/QuestionnaireDomainList.vue')
  },
  {
    path: 'questionnaires/:id/domains/:domainId',
    name: needManagerRoutesNames.needManagerQuestionnaireQuestions,
    meta: {
      parentName: needManagerRoutesNames.needManagerQuestionnaires,
      notRenderInSidebar: true
    },
    component: () => import('@/features/questionnaires/QuestionnairesQuestionsStepper.vue')
  },
  {
    path: 'recommendations',
    name: needManagerRoutesNames.needManagerRecommendation,
    meta: {
      routeTestId: 'need-manager-recommendations-route-btn',
      label: 'Recommendations',
      icon: PhSparkle
    },
    component: () => import('@/views/need-manager/recommendations/NeedManagerRecommendations.vue')
  },
  {
    path: 'recommendations/:id',
    name: needManagerRoutesNames.needManagerAddRecommendations,
    meta: {
      notRenderInSidebar: true,
      parentName: needManagerRoutesNames.needManagerRecommendation
    },
    component: () => import('@/views/need-manager/recommendations/NeedManagerAddRecommendation.vue')
  },
  {
    path: 'feedback',
    name: needManagerRoutesNames.needManagerFeedbackList,
    meta: {
      label: 'Feedback',
      icon: PhListPlus
    },
    component: () => import('@/features/feedback/FeedbackList.vue')
  },
  {
    path: 'feedback/:id',
    name: needManagerRoutesNames.needManagerAddFeedback,
    meta: {
      notRenderInSidebar: true,
      parentName: needManagerRoutesNames.needManagerFeedbackList
    },
    component: () => import('@/features/feedback/FeedbackAnswers.vue')
  },
  {
    path: 'directory',
    name: needManagerRoutesNames.needManagerDirectory,
    meta: {
      label: 'Directory',
      icon: PhUsers
    },
    component: () => import('@/features/directory/StaffDirectory.vue')
  },
  {
    path: 'students',
    name: needManagerRoutesNames.needManagerStudents,
    meta: {
      routeTestId: 'need-manager-students-route-btn',
      label: 'Students',
      icon: PhStudent
    },
    component: () => import('@/features/students/StudentsList.vue')
  },
  {
    path: 'students/manage-students',
    name: needManagerRoutesNames.needManagerManageStudents,
    meta: {
      parentName: needManagerRoutesNames.needManagerStudents,
      notRenderInSidebar: true
    },
    component: () => import('@/views/need-manager/students/NeedManagerManageStudents.vue')
  },
  {
    path: 'groups',
    name: needManagerRoutesNames.needManagerGroups,
    meta: {
      label: 'Groups',
      icon: PhGlobeStand
    },
    component: () => import('@/features/groups/GroupsManagement.vue')
  },
  {
    path: 'groups/:id',
    name: needManagerRoutesNames.needManagerGroupStudents,
    meta: { notRenderInSidebar: true, parentName: needManagerRoutesNames.needManagerGroups },
    component: () => import('@/features/groups/GroupStudents.vue')
  }
]

export {
  needManagerRoutesNames,
  needManagerRoutes
}
